import { render, staticRenderFns } from "./LearningByProgram.vue?vue&type=template&id=4c7fc0aa&scoped=true"
import script from "./LearningByProgram.vue?vue&type=script&lang=js"
export * from "./LearningByProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7fc0aa",
  null
  
)

export default component.exports